const imageBaseurl = "";
const imageUrls = {
  logo: imageBaseurl + "/assets/new_logo.jpg",
  sihnup: imageBaseurl + "/assets/doctor2.png",
  signin: imageBaseurl + "/assets/new_doctor.jpg",
  facilities: imageBaseurl + "/assets/facilities.svg"
};
export { imageUrls };
